import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const envFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const fallbackFirebaseConfig = {
  apiKey: 'AIzaSyBwQkE5wC6jyPZye14xMUGSHg702ln976U',
  authDomain: 'oomfs.firebaseapp.com',
  projectId: 'gmail-oomfs',
  storageBucket: 'gmail-oomfs.firebasestorage.app',
  messagingSenderId: '698130733503',
  appId: '1:698130733503:web:48f68fbff0dc51c19a290a',
};

const hasEnvFirebaseConfig = Object.values(envFirebaseConfig).every(
  (value) => typeof value === 'string' && value.trim().length > 0,
);

const firebaseConfig = hasEnvFirebaseConfig
  ? envFirebaseConfig
  : fallbackFirebaseConfig;

export const hasFirebaseConfig = Object.values(firebaseConfig).every(
  (value) => typeof value === 'string' && value.trim().length > 0,
);

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);